// export const statusDataSource = [
//   {
//     value: 1,
//     text: "All Status",
//   },
//   {
//     value: 2,
//     text: "Open",
//   },
//   {
//     value: 3,
//     text: "Work in progress",
//   },
//   {
//     value: 4,
//     text: "Escalated",
//   },
//   {
//     value: 5,
//     text: "Solved",
//   },
// ];

export const statusDataSource = [
  {
    value: "All Status",
    text: "All Status",
  },
  {
    value: "Open",
    text: "Open",
  },
  {
    value: "Work in Progress",
    text: "Work in Progress",
  },
  {
    value: "Escalated",
    text: "Escalated",
  },
  {
    value: "Solved",
    text: "Solved",
  },
];

export const statusDataSource2 = [
  {
    value: 1,
    text: "Open",
  },
  {
    value: 2,
    text: "Work in progress",
  },
  {
    value: 3,
    text: "Escalated",
  },
  {
    value: 4,
    text: "Solved",
  },
];

export const priorityDataSource = [
  {
    value: 1,
    text: "High",
  },
  {
    value: 2,
    text: "Medium",
  },
  {
    value: 3,
    text: "Low",
  },
];

// export const timeDataSource = [
//   {
//     value: 1,
//     text: "All Time",
//   },
//   {
//     value: 2,
//     text: "Today",
//   },
//   {
//     value: 3,
//     text: "Yesterday",
//   },
//   {
//     value: 4,
//     text: "This Week",
//   },
//   {
//     value: 5,
//     text: "Last Week",
//   },
//   {
//     value: 6,
//     text: "Last 15 days",
//   },
//   {
//     value: 7,
//     text: "This Month",
//   },
//   {
//     value: 8,
//     text: "Last Month",
//   },
//   {
//     value: 9,
//     text: "Quaterly",
//   },
//   {
//     value: 7,
//     text: "This Year",
//   }
// ];

//// rishabh code
export const timeDataSource = [
  { id: 1, name: "All Time", value: 1 },
  { id: 2, name: "Today", value: 2 },
  { id: 3, name: "Yesterday", value: 3 },
  { id: 4, name: "This Week", value: 4 },
  { id: 5, name: "This Month", value: 5 },
  // { id: 6, name: "Past", value: 6 },
];

export const timespentDataSource = [
  {
    value: 1,
    text: "All Time",
  },
  {
    value: 2,
    text: "Today",
  },
  {
    value: 3,
    text: "Yesterday",
  },
  {
    value: 4,
    text: "This Week",
  },
  {
    value: 5,
    text: "This Month",
  },
  // {
  //   value: 6,
  //   text: "Past Time",
  // },
];

export const notesDataSource = [
  {
    value: 1,
    text: "All Notes",
  },
  {
    value: 2,
    text: "Your Notes",
  },
  {
    value: 3,
    text: "Customer Notes",
  },
  {
    value: 4,
    text: "Other User Notes",
  },
];

//// rishab code
export const custNotesDataSource = [
  {
    value: 1,
    text: "All Notes",
  },
  {
    value: 2,
    text: "Your Notes",
  },
  // {
  //   value: 4,
  //   text: "Other User Notes",
  // },
];
export const sortTicketData = [
  // {
  //   id: "date",
  //   text: "Updated Date",
  //   categoryId: "updatedDate",
  //   items: [
  //     {
  //       id: "date_asc",
  //       text: "Ascending",
  //       field: "update_date",
  //       order: "asc",
  //       categoryId: "date",
  //     },
  //     {
  //       id: "date_desc",
  //       text: "Descending",
  //       field: "update_date",
  //       order: "desc",
  //       categoryId: "date",
  //     },
  //   ],
  // },
  {
    id: "entry",
    text: "Created Date",
    items: [
      {
        id: "entry_asc",
        text: "Oldest to New",
        field: "entry_date_obj",
        order: "asc",
        categoryId: "entry",
      },
      {
        id: "entry_desc",
        text: "Newest to Oldest",
        field: "entry_date_obj",
        order: "desc",
        categoryId: "entry",
      },
    ],
  },
  {
    id: "priority",
    text: "Priority",
    categoryId: 1,
    items: [
      {
        id: "priority_asc",
        text: "Low to High",
        field: "ticketpriority_fk",
        order: "asc",
        categoryId: "priority",
      },
      {
        id: "priority_desc",
        text: "High to Low",
        field: "ticketpriority_fk",
        categoryId: "priority",
        order: "desc",
      },
    ],
  },
];
